import i18n from '../lib/i18n'

export const friendlyMessages = {
  // Existing app-level validation messages
  'Txt description cannot be blank.': i18n.t(`Preview cannot be blank.`),

  // --- System / HTTP error responses ---
  'Request failed with status code 400': i18n.t('Bad request. Please check your input and try again.'),
  'Request failed with status code 401': i18n.t('Unauthorized. Please log in again.'),
  'Request failed with status code 403': i18n.t('You do not have permission to perform this action.'),
  'Request failed with status code 404': i18n.t('The requested resource could not be found.'),
  'Request failed with status code 406': i18n.t('Request not acceptable. Please try a different format.'),
  'Request failed with status code 408': i18n.t('The request timed out. Please try again.'),
  'Request failed with status code 429': i18n.t('Too many requests. Please wait and try again later.'),
  'Request failed with status code 500': i18n.t('The server encountered a problem. Please try again later.'),
  'Request failed with status code 501': i18n.t('Server does not support this operation.'),
  'Request failed with status code 502': i18n.t('Bad gateway. The upstream server returned an invalid response.'),
  'Request failed with status code 503': i18n.t('Service unavailable. Please try again in a few minutes.'),
  'Request failed with status code 504': i18n.t('Gateway timeout. The server took too long to respond.'),

  // --- Generic catch-all fallback ---
  'Network Error': i18n.t('Network connection issue. Please check your internet connection and try again.'),
}
